import React, { PureComponent } from "react";
import axios from "axios";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Input,
  Label,
  Button,
} from "reactstrap";
import LoaderSpinner from "../Widgets/LoaderSpinner";
import authProtection from "../../HOCs/authProtection";
import withAlertTimeout from "../../HOCs/withAlertTimeout";
import Alert from "../Widgets/Alert";

class AdminRoutes extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      businessID: "",
      sectionID: "",
      errorMessage: "Something went wrong, please try again",
      successMessage: 'Successful',
      isSubmitting: false
    };

    this.onQueryInput = this.onQueryInput.bind(this);
    this.onSubmitRetrieve = this.onSubmitRetrieve.bind(this);
    this.onSubmitRefresh = this.onSubmitRefresh.bind(this);
    this.isSuperAdmin = false;
  }

  componentDidMount() {
    document.querySelector("#business-id-input").focus();

    const user = JSON.parse(sessionStorage.getItem("user"));
    if (
      user.privyData.group.goNation.some(item => item.name === "SuperAdmin")
    ) {
      this.isSuperAdmin = true;
    }
  }

  onQueryInput(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onSubmitRefresh() {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    this.setState({ isSubmitting: true });
    axios
    .post(
      `api/proxy/v2/businesses/${this.state.businessID}/refreshInventory`,
      { headers }
    )
    .then((res) => {
        if(res.length === 0) 
        {
            this.setState(
                {successMessage: 'Refreshed Successfully'},
                this.props.showSuccess
            )
        }
        else 
        {
            this.setState(
                {errorMessage: 'Something went wrong, please try again'},
                this.props.showFailure
            );
        }
    })
    .catch((error)=> {
        this.setState(
            {errorMessage: error.response.data.error},
            this.props.showFailure
        );
    })
    .finally(() => {
      this.setState({ isSubmitting: false });
    });
  }

  onSubmitRetrieve() {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    this.setState({ isSubmitting: true });

    axios
    .put(
      `api/proxy/v2/sections/${this.state.sectionID}/revert`, null,
      {headers: headers}
    )
    .then((res) => {
      
        if(res.data === "") 
        {
            this.setState(
                {successMessage: 'Retrieved Successfully'},
                this.props.showSuccess
            )
        }
        else 
        {
            this.setState(
                {errorMessage: 'Something went wrong, please try again'},
                this.props.showFailure
            );
        }
    })
    .catch((error)=> {
        this.setState(
            {errorMessage: error.response.data.error},
            this.props.showFailure
        );
    })
    .finally(() => {
      this.setState({ isSubmitting: false });
    });
  }

  submitAnalytics = () => {
     const token = sessionStorage.getItem('token')
     const headers = { Authorization: `Bearer ${token}` }
     this.setState({ isSubmitting: true })
     
    const bizID = this.state.analyticsBizID
    const analyticsID = this.state.analyticsID
    console.log('submitting: ', bizID, analyticsID)
    axios
      .patch(
        `api/proxy/v2/businesses/${bizID}/settings`,
        {
          analyticsKey: analyticsID,
        },
        { headers }
      )
      .then(response => {
        this.setState(
          {successMessage: 'Analytics Key Added Successfully.'},
          this.props.showSuccess
        )
        this.setState({isSubmitting: false})
      })
      .catch(err => {
        this.setState(
          {errorMessage: 'Something went wrong, please try again'},
          this.props.showFailure
        );
        console.log(err)
      })
  }

  removeAnalytics = () => {
    const token = sessionStorage.getItem('token')
    const headers = { Authorization: `Bearer ${token}` }
    this.setState({ isSubmitting: true })
    
   const bizID = this.state.analyticsRemoveBizID
   console.log('submitting: ', bizID, '')
   axios
     .patch(
       `api/proxy/v2/businesses/${bizID}/settings`,
       {
         analyticsKey: '',
       },
       { headers }
     )
     .then(response => {
      this.setState(
        {successMessage: 'Analytics Key Removed Successfully.'},
        this.props.showSuccess
      )
       this.setState({isSubmitting: false})
     })
     .catch(err => {
        this.setState(
          {errorMessage: 'Something went wrong, please try again'},
          this.props.showFailure
        );
        console.log(err)
     })
 }

  render() {

    return [
      <Row>
        <Col xs='12'>
          <Card>
            <CardHeader>Admin Routes</CardHeader>
            <CardBody>
              {
                <Alert
                  active={this.props.success}
                  message={this.state.successMessage}
                />
              }
              {
                <Alert
                  type='danger'
                  active={this.props.failure}
                  message={this.state.errorMessage}
                />
              }
              <FormGroup>
                <Label htmlFor='business ID'>Refresh the Inventory</Label>
                <Input
                  type='text'
                  name='businessID'
                  id='business-id-input'
                  placeholder='Enter Business ID. (e.g. bzn--mUJlTrQRUm0vW1hq8DJyQ)'
                  value={this.state.businessID}
                  onChange={this.onQueryInput}
                />
              </FormGroup>
              <div
                className='form-actions'
                style={{
                  paddingBottom: '20px',
                  marginBottom: '15px',
                  borderBottom: '1.5px solid #eee',
                }}>
                <Button
                  onClick={this.onSubmitRefresh}
                  type='submit'
                  color='primary'
                  disabled={this.state.isSubmitting}>
                  Submit
                </Button>
              </div>

              <FormGroup>
                <Label htmlFor='section ID'>Retrieve Menu Section</Label>
                <Input
                  type='text'
                  name='sectionID'
                  placeholder='Enter Section ID. (e.g. sec-lNzMTBo2TeGwa3oJrjZo-g)'
                  value={this.state.sectionID}
                  onChange={this.onQueryInput}
                />
              </FormGroup>
              <div
                className='form-actions'
                style={{
                  paddingBottom: '20px',
                  marginBottom: '15px',
                  borderBottom: '1.5px solid #eee',
                }}>
                <Button
                  onClick={this.onSubmitRetrieve}
                  type='submit'
                  color='primary'
                  disabled={this.state.isSubmitting}>
                  Submit
                </Button>
              </div>

              <FormGroup>
                <Label htmlFor='section ID'>Add Analytics ID</Label>
                <div style={{display: 'flex'}}>
                  <Input
                    type='text'
                    name='analyticsBizID'
                    placeholder='Enter Business ID'
                    value={this.state.analyticsBizID}
                    onChange={this.onQueryInput}
                  />
                  <Input
                    type='text'
                    name='analyticsID'
                    placeholder='Enter google analytics view ID'
                    value={this.state.analyticsID}
                    onChange={this.onQueryInput}
                    style={{marginLeft: '20px'}}
                  />
                </div>
              </FormGroup>
              <div className='form-actions'
               style={{
                paddingBottom: '20px',
                marginBottom: '15px',
                borderBottom: '1.5px solid #eee',
              }}>
                <Button
                  onClick={this.submitAnalytics}
                  type='submit'
                  color='primary'
                  disabled={this.state.isSubmitting}>
                  Submit
                </Button>
              </div>

              <FormGroup>
                <Label htmlFor='section ID'>Remove Analytics ID</Label>
                <div style={{display: 'flex' }}>
                  <Input
                    type='text'
                    name='analyticsRemoveBizID'
                    placeholder='Enter Business ID'
                    value={this.state.analyticsRemoveBizID}
                    onChange={this.onQueryInput}
                  />
                </div>
              </FormGroup>

              <div className='form-actions'>
                <Button
                  onClick={this.removeAnalytics}
                  type='submit'
                  color='primary'
                  disabled={this.state.isSubmitting}>
                  Submit
                </Button>
              </div>
            </CardBody>
          </Card>
          {this.state.isSubmitting && <LoaderSpinner />}
        </Col>
      </Row>,
    ]
  }
}

export default authProtection(withAlertTimeout(AdminRoutes));


// WEBPACK FOOTER //
// ./src/views/Pages/AdminRoutes.js